<template>
	<div class="c-weektime">
		<div class="c-schedue"></div>
		<div :class="{ 'c-schedue': true, 'c-schedue-notransi': mode }" :style="styleValue"></div>

		<table :class="{ 'c-min-table': colspan < 2 }" class="c-weektime-table">
			<thead class="c-weektime-head">
				<tr>
					<th rowspan="8" class="week-td">星期/时间</th>
					<th :colspan="12 * colspan">00:00 - 12:00</th>
					<th :colspan="12 * colspan">12:00 - 24:00</th>
				</tr>
				<tr>
					<td v-for="t in theadArr" :key="t" :colspan="colspan">{{ t }}</td>
				</tr>
			</thead>
			<tbody class="c-weektime-body">
				<tr v-for="t in data" :key="t.row">
					<td>{{ t.value }}</td>
					<td
						v-for="n in t.child"
						:key="`${n.row}-${n.col}`"
						:data-week="n.row"
						:data-time="n.col"
						:class="selectClasses(n)"
						@mouseenter="cellEnter(n)"
						@mousedown="cellDown(n)"
						@mouseup="cellUp(n)"
						class="weektime-atom-item"
					></td>
				</tr>
				<tr>
					<td colspan="49" class="c-weektime-preview">
						<div class="g-clearfix c-weektime-con">
							<span class="g-pull-left">{{
								selectState ? '已选择时间段' : '可拖动鼠标选择时间段'
							}}</span>
							<el-link @click.prevent="clearWeektime" class="g-pull-right" :underline="false"
								>清空选择</el-link
							>
						</div>
						<div v-if="selectState" class="c-weektime-time">
							<div v-for="t in selectValue" :key="t.id">
								<p v-if="t.value">
									<span class="g-tip-text">{{ t.week }}：</span>
									<span>{{ t.value }}</span>
								</p>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
import weektimeData from './weekData';
const createArr = len => {
	return Array.from(Array(len)).map((ret, id) => id);
};
export default {
	name: 'DragWeektime',
	props: {
		value: {
			type: String,
			default: ''
		},
		colspan: {
			type: Number,
			default() {
				return 2; //1:粒度为1h,2:粒度为30min
			}
		}
	},
	watch: {
		value: {
			handler: function(val) {
				if (val) {
					let values = val.split('');
					let index = 0;
					this.data.forEach((item, row) => {
						item.child.forEach((ch, col) => {
							if (ch.row == row && ch.col == col) {
								let isCheck = values[index] == 1 ? true : false;
								this.$set(ch, 'check', isCheck);
								index++;
							}
						});
					});
				} else {
					// value为空时，清空上次已选
					this.clearWeektime();
				}
			},
			immediate: true
		}
	},
	data() {
		return {
			width: 0,
			height: 0,
			left: 0,
			top: 0,
			mode: 0,
			row: 0,
			col: 0,
			theadArr: [],
			data: weektimeData(this.colspan)
		};
	},
	computed: {
		styleValue() {
			return {
				width: `${this.width}px`,
				height: `${this.height}px`,
				left: `${this.left}px`,
				top: `${this.top}px`
			};
		},
		selectValue() {
			return this.data.map(item => {
				return {
					id: item.row,
					week: item.value,
					value: this.splicing(item.child)
				};
			});
		},
		selectState() {
			return this.value.length;
		},
		selectClasses() {
			return n => (n.check ? 'ui-selected' : '');
		}
	},
	created() {
		this.theadArr = createArr(24);
	},
	methods: {
		cellEnter(item) {
			const ele = document.querySelector(`td[data-week='${item.row}'][data-time='${item.col}']`);
			if (ele && !this.mode) {
				this.left = ele.offsetLeft;
				this.top = ele.offsetTop;
			} else if (item.col <= this.col && item.row <= this.row) {
				this.width = (this.col - item.col + 1) * ele.offsetWidth;
				this.height = (this.row - item.row + 1) * ele.offsetHeight;
				this.left = ele.offsetLeft;
				this.top = ele.offsetTop;
			} else if (item.col >= this.col && item.row >= this.row) {
				this.width = (item.col - this.col + 1) * ele.offsetWidth;
				this.height = (item.row - this.row + 1) * ele.offsetHeight;
				if (item.col > this.col && item.row === this.row) {
					this.top = ele.offsetTop;
				}
				if (item.col === this.col && item.row > this.row) {
					this.left = ele.offsetLeft;
				}
			} else if (item.col > this.col && item.row < this.row) {
				this.width = (item.col - this.col + 1) * ele.offsetWidth;
				this.height = (this.row - item.row + 1) * ele.offsetHeight;
				this.top = ele.offsetTop;
			} else if (item.col < this.col && item.row > this.row) {
				this.width = (this.col - item.col + 1) * ele.offsetWidth;
				this.height = (item.row - this.row + 1) * ele.offsetHeight;
				this.left = ele.offsetLeft;
			}
		},
		cellDown(item) {
			const ele = document.querySelector(`td[data-week='${item.row}'][data-time='${item.col}']`);
			this.check = Boolean(item.check);
			this.mode = 1;
			if (ele) {
				this.width = ele.offsetWidth;
				this.height = ele.offsetHeight;
			}

			this.row = item.row;
			this.col = item.col;
		},
		cellUp(item) {
			if (item.col <= this.col && item.row <= this.row) {
				this.selectWeek([item.row, this.row], [item.col, this.col], !this.check);
			} else if (item.col >= this.col && item.row >= this.row) {
				this.selectWeek([this.row, item.row], [this.col, item.col], !this.check);
			} else if (item.col > this.col && item.row < this.row) {
				this.selectWeek([item.row, this.row], [this.col, item.col], !this.check);
			} else if (item.col < this.col && item.row > this.row) {
				this.selectWeek([this.row, item.row], [item.col, this.col], !this.check);
			}

			this.width = 0;
			this.height = 0;
			this.mode = 0;
		},
		selectWeek(row, col, check) {
			const [minRow, maxRow] = row;
			const [minCol, maxCol] = col;
			this.data.forEach(item => {
				item.child.forEach(t => {
					if (t.row >= minRow && t.row <= maxRow && t.col >= minCol && t.col <= maxCol) {
						this.$set(t, 'check', check);
					}
				});
			});
			this.change();
		},
		clearWeektime() {
			this.data.forEach(item => {
				item.child.forEach(t => {
					this.$set(t, 'check', false);
				});
			});
			this.change();
		},
		splicing(list) {
			let same;
			let i = -1;
			const len = list.length;
			const arr = [];

			if (!len) return;
			while (++i < len) {
				const item = list[i];
				if (item.check) {
					if (item.check !== Boolean(same)) {
						arr.push(...['、', item.begin, '~', item.end]);
					} else if (arr.length) {
						arr.pop();
						arr.push(item.end);
					}
				}
				same = Boolean(item.check);
			}
			arr.shift();
			return arr.join('');
		},
		change() {
			let val = this.data
				.map(item => {
					let str = item.child.map(ch => {
						return ch.check ? 1 : 0;
					});
					return str.join('');
				})
				.join('');
			this.$emit('change', val);
		}
	}
};
</script>
<style lang="scss">
.c-weektime {
	min-width: 640px;
	position: relative;
	display: inline-block;
}

.c-schedue {
	background: #00BFBC;
	position: absolute;
	width: 0;
	height: 0;
	opacity: 0.6;
	pointer-events: none;
}

.c-schedue-notransi {
	transition: width 0.12s ease, height 0.12s ease, top 0.12s ease, left 0.12s ease;
}

.c-weektime-table {
	border-collapse: collapse;

	th {
		vertical-align: inherit;
		font-weight: bold;
	}

	tr {
		height: 30px;
	}

	tr,
	td,
	th {
		user-select: none;
		border: 1px solid #E4E7ED;
		text-align: center;
		min-width: 12px;
		line-height: 1.8em;
		transition: background 0.2s ease;
	}

	.c-weektime-head {
		font-size: 12px;

		.week-td {
			width: 70px;
		}
	}

	.c-weektime-body {
		font-size: 12px;

		td {
			&.weektime-atom-item {
				user-select: unset;
				background-color: #F8F8F8;
				cursor: pointer;
			}

			&.ui-selected {
				background-color: #00BFBC;
			}
		}
	}

	.c-weektime-preview {
		line-height: 2.4em;
		padding: 0 10px;
		font-size: 14px;

		.c-weektime-con {
			line-height: 46px;
			user-select: none;
		}

		.c-weektime-time {
			text-align: left;
			line-height: 2.4em;

			p {
				max-width: 625px;
				line-height: 1.4em;
				word-break: break-all;
				margin-bottom: 8px;
			}
		}
	}
}

.c-min-table {
	tr,
	td,
	th {
		min-width: 24px;
	}
}

.g-clearfix {
	&::after,
	&::before {
		clear: both;
		content: ' ';
		display: table;
	}
}

.g-pull-left {
	float: left;
}

.g-pull-right {
	float: right;
}

.g-tip-text {
	color: #999;
}
</style>
